module.exports = __webpack_public_path__ + "img/logo_bal.89cdbd70.png";